import {Component} from 'react';

export default class getServices extends Component {
    getResources = async (url, fragment) => {
        let getData = await fetch(`https://numbersapi.p.rapidapi.com/${url}?${fragment}`, {
            "method": "GET",
            "headers": {
                "x-rapidapi-host": "numbersapi.p.rapidapi.com",
                "x-rapidapi-key": "1340330ecbmsh678efbe6baabecep150962jsn173f29d7a896"
            }
        });

        if (!getData.ok) {
            throw new Error (`You have problem with your \`https://numbersapi.p.rapidapi.com/${url}?${fragment}\`, status: ${getData.status}`);
        }

        return  getData.json();
    }

    getData = async (id, fragment) => {
        const ourDate = await this.getResources(`${id}`, `${fragment}`);
        return this._transformNumber(ourDate);
    }

    _transformNumber(data) {
        const convertedNumber = data.number.toString();
        let NewArr = [];
        for (let i = 0; i < convertedNumber.length; i++) {
            NewArr.push(convertedNumber[i]);
        }



        let AddDateFromNumber = '';
        if(data.type === 'date') {
            const dates = getArrMonthWithDates();
            AddDateFromNumber = dates[data.number];
        }

        return {
            found: data.found,
            ReNumber: NewArr,
            number: data.number,
            type: '/' + data.type,
            text: AddDateFromNumber + data.text
        };
    }
}


const getArrMonthWithDates = () => {
    const ArrMonths = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const MonthsWith31days = [
        "January",
        "March",
        "May",
        "July",
        "August",
        "October",
        "December",
    ];
    const MonthsWith30days = ["April", "June", "September", "November"];
    const MonthsWith29days = ["February"];


    let NewArrWithDate = ['0'];
    for (let i = 0; i < ArrMonths.length; i++){
        let Days;

        if ( MonthsWith31days.indexOf(ArrMonths[i]) > -1 ) {
            Days = 31;
        } else if ( MonthsWith30days.indexOf(ArrMonths[i]) > -1 ) {
            Days = 30;
        } else if ( MonthsWith29days.indexOf(ArrMonths[i]) > -1 ) {
            Days = 29;
        }

        for ( let d = 1; d <= Days; d++ )
            if( d === 1 || d === 21 || d === 31 ) {
                NewArrWithDate.push( `${ArrMonths[i]} ${d}st ` );
            } else if ( d === 2 || d === 22 ) {
                NewArrWithDate.push( `${ArrMonths[i]} ${d}nd ` );
            } else if ( d === 3 || d === 23 ) {
                NewArrWithDate.push( `${ArrMonths[i]} ${d}rd ` );
            } else {
                NewArrWithDate.push( `${ArrMonths[i]} ${d}th ` );
            }
    }
    return NewArrWithDate;
}